import { useAtomValue } from 'jotai';
import { templatesSortState } from './account-management.state';
import { useTemplates } from './use-templates.query';
import { TemplateFileType } from '@/api/v4/template.api';
import { orderBy } from 'lodash-es';

const fileTypes = Object.values(TemplateFileType);

export const useTemplatesOrder = () => {
  const { data = [] } = useTemplates();
  const sorting = useAtomValue(templatesSortState);

  return orderBy(
    fileTypes.map(fileType => {
      const template = data.find(d => d.fileType === fileType);

      return {
        fileType,
        template,
      };
    }),
    record => {
      if (
        sorting?.sort === 'fileType' &&
        typeof record === 'object' &&
        'fileType' in record
      )
        return record.fileType;
      if (
        sorting?.sort === 'createdDate' &&
        typeof record === 'object' &&
        'template' in record
      ) {
        const date = record.template?.createdDate;
        return date ? new Date(date).getTime() : -Infinity;
      }
      return 0;
    },
    [sorting?.direction ?? 'desc'],
  );
};
